import { getSiteID } from '@/utils/helper'
import { loadVolume, saveVolume } from '@/utils/volume'

const state = {
  siteID: 0,
  user: null,
  token: '',
  route: null,
  volume: 1, // 音量 0 ～ 1
  faceList: [], //所有年龄的脸部图片
  faceHash: '', // 上传视频，图片后，生成的哈希值，结果页的二维码需要
  diGiVideoList: [], //数字人的视频地址集合
  diGiVideoUrl: '' //数字人详情显示的视频地址
}

const mutations = {
  SET_USER(state, user) {
    state.user = user
  },
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_ROUTE(state, route) {
    state.route = route
  },
  SET_FACE_LIST(state, faceList) {
    state.faceList = faceList
  },
  SET_FACE_HASH(state, faceHash) {
    state.faceHash = faceHash
  },
  INIT_SITE_ID(state, siteID) {
    state.siteID = getSiteID({ siteID })

    // 设置localStorage
    localStorage.setItem('siteID', state.siteID)
  },
  SET_VOLUME(state, volume) {
    state.volume = volume

    // 设置localStorage
    saveVolume(volume)
  },
  SET_DIGI_VIDEO_LIST(state, diGiVideoList) {
    state.diGiVideoList = diGiVideoList
  },
  SET_DIGI_VIDEO_URL(state, diGiVideoUrl) {
    state.diGiVideoUrl = diGiVideoUrl
  },
  CLEAR(state) {
    state.user = null
    state.token = ''
    state.faceList = []
    state.faceHash = ''
    state.diGiVideoList = []
    state.diGiVideoUrl = ''
    let siteID = state.siteID
    localStorage.clear()
    sessionStorage.clear()
    localStorage.setItem('siteID', siteID)
  }
}

const actions = {
  set_user({ commit }, user) {
    commit('SET_USER', user)
  },
  set_token({ commit }, token) {
    commit('SET_TOKEN', token)
  },
  set_route({ commit }, route) {
    commit('SET_ROUTE', route)
  },
  set_face_list({ commit }, faceList) {
    commit('SET_FACE_LIST', faceList)
  },
  set_face_hash({ commit }, faceHash) {
    commit('SET_FACE_HASH', faceHash)
  },
  init_site_id({ commit }, siteID) {
    // 获取老的siteID
    const oldSiteID = state.siteID

    // 初始化siteID
    commit('INIT_SITE_ID', siteID)

    // 获取新的siteID
    const newSiteID = state.siteID

    // 如果已有siteID，且新旧siteID不一致，则清空用户信息
    if (oldSiteID && oldSiteID !== newSiteID) {
      commit('CLEAR')
    }
  },
  init_volume({ commit }) {
    const volume = loadVolume()
    commit('SET_VOLUME', volume)
  },
  set_volume({ commit }, volume) {
    commit('SET_VOLUME', volume)
  },
  set_digi_video_list({ commit }, diGiVideoList) {
    commit('SET_DIGI_VIDEO_LIST', diGiVideoList)
  },
  set_digi_video_url({ commit }, diGiVideoUrl) {
    commit('SET_DIGI_VIDEO_URL', diGiVideoUrl)
  },
  clear({ commit }) {
    commit('CLEAR')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
